import React from 'react';
import { CalendarIcon } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function SixtyDayPlan() {
  const steps = [{
    week: 'Semana 1',
    task: '“hoy vas a recortar 3 fugas”'
  }, {
    week: 'Semana 2',
    task: '“esta semana armas tu calendario de pagos”'
  }, {
    week: 'Semana 3',
    task: '“hoy eliges tu estrategia de deuda”'
  }, {
    week: 'Semana 4',
    task: '“configuras automatización el día de pago”'
  }];
  return <section className="py-24 relative overflow-hidden" data-id="element-247">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-248">
        <FadeIn data-id="element-249">
          <div className="text-center mb-16" data-id="element-250">
            <div className="inline-flex items-center justify-center p-3 bg-gold-500/10 rounded-full mb-6 text-gold-500" data-id="element-251">
              <CalendarIcon className="w-8 h-8" data-id="element-252" />
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-253">
              Lo mejor: no estás sola
            </h2>
            <p className="text-xl text-slate-300 max-w-2xl mx-auto" data-id="element-254">
              Este libro te lleva con un plan de 60 días, semana por semana, con
              tareas claras.
            </p>
          </div>
        </FadeIn>

        <div className="relative max-w-3xl mx-auto" data-id="element-255">
          {/* Connecting Line */}
          <div className="absolute left-8 md:left-1/2 top-0 bottom-0 w-px bg-gradient-to-b from-gold-500/50 via-gold-500/20 to-transparent transform md:-translate-x-1/2" data-id="element-256" />

          <div className="space-y-12" data-id="element-257">
            {steps.map((step, index) => <FadeIn key={index} delay={index * 0.2} direction={index % 2 === 0 ? 'right' : 'left'} data-id="element-258">
                <div className={`relative flex items-center md:justify-between ${index % 2 === 0 ? 'md:flex-row-reverse' : ''}`} data-id="element-259">
                  {/* Timeline Dot */}
                  <div className="absolute left-8 md:left-1/2 w-4 h-4 rounded-full bg-gold-500 transform -translate-x-1/2 shadow-[0_0_15px_rgba(201,168,76,0.6)] z-10" data-id="element-260" />

                  {/* Content Card */}
                  <div className={`ml-16 md:ml-0 w-full md:w-[45%] ${index % 2 === 0 ? 'md:pl-8' : 'md:pr-8 text-left md:text-right'}`} data-id="element-261">
                    <div className="glass-card relative overflow-hidden group" data-id="element-262">
                      <div className="absolute top-0 left-0 w-full h-1 bg-gold-500/50 transform origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-500" data-id="element-263" />
                      <span className="text-sm font-bold text-gold-500 uppercase tracking-wider mb-2 block" data-id="element-264">
                        {step.week}
                      </span>
                      <p className="text-lg text-white font-medium italic" data-id="element-265">
                        {step.task}
                      </p>
                    </div>
                  </div>

                  {/* Empty space for opposite side on desktop */}
                  <div className="hidden md:block w-[45%]" data-id="element-266" />
                </div>
              </FadeIn>)}
          </div>
        </div>

        <FadeIn delay={0.8} data-id="element-267">
          <div className="text-center mt-16" data-id="element-268">
            <p className="text-2xl font-bold text-gold-400" data-id="element-269">
              Cero adivinanza. Cero 'a ver si me sale'.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}